import { combineReducers } from 'redux';

import screenReducer from './reducers/screenReducer';
import gameDetailsReducer from './reducers/gameDetailsReducer';
import roundReducer from './reducers/roundReducer';
import displayReducer from './reducers/displayReducer';
import practiceReducer from './reducers/practiceReducer';
import alexReducer from './reducers/alexReducer';
import instructionReducer from './reducers/instructionReducer';
import onboardingReducer from './reducers/onboardingReducer';

// keeping the reducer collection as a separate exported object enables us
// to do some light test automation on every reducer.
// see ./reducers/__tests__/reducerRejections.test.js
// for more details.
export const reducerCollection = {
  screen: screenReducer,
  gameDetails: gameDetailsReducer,
  round: roundReducer,
  display: displayReducer,
  practice: practiceReducer,
  alex: alexReducer,
  instruction: instructionReducer,
  onboarding: onboardingReducer,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
